export const Footer = () => {
  return (
    <footer className="bg-[#0A0A0A] text-white" data-testid="footer">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Company Info - Left Half */}
          <div>
            <h3 
              className="text-2xl font-bold tracking-tight uppercase mb-4"
              style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
            >
              CATWORTH GROUP
            </h3>
            <p className="text-neutral-400 text-sm leading-relaxed max-w-md">
              Industrial Manufacturing & Wear Solutions. Serving the mining and heavy industry sectors across South Africa and beyond.
            </p>
            <p className="text-neutral-500 text-sm mt-2">
              An industrial division of BlackScott Holdings.
            </p>
            
            {/* BlackScott Holdings */}
            <div className="mt-6 pt-6 border-t border-neutral-800">
              <div className="flex items-center gap-4">
                <div>
                  <p className="text-xs font-bold tracking-[0.15em] uppercase text-neutral-500 mb-2">
                    BlackScott Holdings
                  </p>
                  <p className="text-neutral-500 text-xs leading-relaxed max-w-xs">
                    A diversified group operating across industrial manufacturing, logistics, technology, and emerging ventures.
                  </p>
                </div>
                <img 
                  src="https://customer-assets.emergentagent.com/job_catworth-group/artifacts/v53zrhg8_Group%2051%20%281%29.svg" 
                  alt="BlackScott Holdings"
                  className="h-14 w-auto flex-shrink-0"
                />
              </div>
            </div>
          </div>

          {/* Locations & Contact - Right Half */}
          <div>
            <h4 
              className="text-xs font-bold tracking-[0.2em] uppercase text-neutral-500 mb-4"
            >
              Locations & Contact
            </h4>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
              <ul className="space-y-1 text-sm text-neutral-400">
                <li>Cnr All Black & Tile Rd</li>
                <li>Anderbolt, Boksburg</li>
                <li>Gauteng, 1459</li>
              </ul>
              <ul className="space-y-1 text-sm text-neutral-400">
                <li>Cnr Bird and Guile Rd</li>
                <li>Lilianton, Boksburg</li>
                <li>Gauteng, 1459</li>
              </ul>
              <ul className="space-y-1 text-sm text-neutral-400 break-all sm:break-normal">
                <li>010 894 6624</li>
                <li className="break-all">enquires@catworth.co.za</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-neutral-800 mt-12 pt-8">
          <p className="text-xs text-neutral-500">
            © {new Date().getFullYear()} BlackScott Holdings. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
